<!--新增用户-->
<template>
  <div v-loading="loading" class="payment-account-user">
    <div class="module">
      <h5 class="module-title">新增用户</h5>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="姓名："
              prop="realName"
              :rules="rules.realName"
              label-width="96px"
            >
              <el-input
                v-model="ruleForm.realName"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="支付平台登录名称："
              prop="paycenterLoginAccount"
              :rules="rules.paycenterLoginAccount"
              label-width="141px"
            >
              <el-input
                v-model="ruleForm.paycenterLoginAccount"
                maxlength="50"
                placeholder="请输入登录名称，仅支持英文字母和数字，最大长度50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="证件信息："
              prop="accountUserAttachTempAOList[0].certificateNo"
              :rules="rules.certificateNo"
              label-width="96px"
              class="document-information"
            >
              <el-select
                v-model="
                  ruleForm.accountUserAttachTempAOList[0].certificateType
                "
                placeholder="请选择"
              >
                <el-option
                  v-for="item in certificateTypeList"
                  :key="item.itemCode"
                  :label="item.itemDisp"
                  :value="item.itemCode"
                ></el-option>
              </el-select>
              <el-input
                v-model="ruleForm.accountUserAttachTempAOList[0].certificateNo"
                placeholder="请输入证件号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="手机号码："
              prop="mobile"
              :rules="rules.mobile"
              label-width="141px"
            >
              <el-input
                v-model="ruleForm.mobile"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="邮箱地址："
              prop="email"
              :rules="rules.email"
              label-width="96px"
            >
              <el-input
                v-model="ruleForm.email"
                placeholder="请输入邮箱地址"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="用户权限："
              prop="role"
              :rules="rules.role"
              label-width="141px"
            >
              <el-checkbox-group v-model="ruleForm.role">
                <el-checkbox label="F002">经办</el-checkbox>
                <el-checkbox label="F003">审核</el-checkbox>
                <el-checkbox
                  v-if="[true, 'true'].includes($route.query?.showQueryRole)"
                  label="F004"
                  >查询</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              label="证件复印件："
              prop="operatorCertificate"
              :rules="rules.attachPath"
              label-width="96px"
            >
              <div class="flex">
                <eui-upload
                  ref="euiUpload1"
                  key-name="auditorCertificate"
                  :file-list="fileListUC"
                  :action="uploadPayCenterFile"
                  :private-upload="privateUpload"
                  :headers="headers"
                  :show-file-list="true"
                  accept=".jpg,.png"
                  single
                  text="上传附件"
                  @handleSuccess="() => userUploadSuccess(fileListUC, 0)"
                >
                </eui-upload>
                <eui-btn type="secondary" @click="previewUploadFile(fileListUC)"
                  >预览
                </eui-btn>
                <span
                  >请上传身份证证件两面清晰的扫描或复印件，并加盖公司红色公章，限≤2mb，jpg、png格式。</span
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="个人信息处理告知同意书："
              prop="notificationLetter"
              :rules="rules.attachPath"
              label-width="185px"
            >
              <div>1.下载信息处理告知同意书模板：</div>
              <div style="margin-top: -10px" class="gray-color">
                <span
                  style="color: #0064c8; cursor: pointer"
                  @click="downloadTemplate()"
                  >点击下载《信息处理告知同意书模板》</span
                >
                下载后填写相关信息，并扫描后上传
              </div>
              <div>2.上传扫描件：</div>
              <div class="flex">
                <eui-upload
                  ref="euiUploadTwo"
                  :file-list="fileListPPN"
                  :action="uploadPayCenterFile"
                  :private-upload="privateUpload"
                  :headers="headers"
                  :show-file-list="true"
                  single
                  accept=".jpg,.png,.pdf"
                  text="上传文件"
                  :picure-width="200"
                  tip="请上传清晰的扫描或复印件。限≤2mb，jpg、png、pdf格式"
                  @handleSuccess="() => userUploadSuccess(fileListPPN, 1)"
                >
                </eui-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--      申请人信息-->
    <applicant-info ref="applicantInfo"></applicant-info>
    <!--      ukey收件人信息-->
    <ukey-recipient-info ref="ukeyRecipientInfo"></ukey-recipient-info>
    <div style="margin-top: 20px" class="footer-button">
      <eui-btn type="secondary" @click="handleConfirmReturn">返 回</eui-btn>
      <div>
        <eui-btn type="weak" @click="handleConfirmReturn">取 消</eui-btn>
        <eui-btn type="primary" @click="handleSubmit">提 交</eui-btn>
      </div>
    </div>
    <viewer-image
      ref="viewer"
      :preview-src-list="[dialogPicUrl]"
    ></viewer-image>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import {
  emailReg,
  idCardReg,
  mobileReg,
} from '@/modules/projectA/utils/verification';
import bus from '@/components/common/bus';
import _ from 'lodash';
import {
  certificateTypeList,
  commonMethodsMixins,
  downloadTemplateUrl,
  headers,
  privateUpload,
  uploadPayCenterFile,
} from '../constant';
import ViewerImage from '../components/viewerImage';
import ApplicantInfo from './applicantInfo';
import UkeyRecipientInfo from './ukeyRecipientInfo';

export default {
  name: 'AddUser',
  components: { ApplicantInfo, UkeyRecipientInfo, ViewerImage },
  mixins: [commonMethodsMixins],
  data() {
    return {
      loading: false,
      fileListUC: [],
      fileListPPN: [],
      uploadPayCenterFile,
      headers,
      // 私有仓库得地址
      privateUpload,
      reUploadFlag: false, // 是否重新上传
      certificateTypeList,
      dialogPicUrl: '',
      ruleForm: {
        accountUserAttachTempAOList: [
          {
            attachName: '',
            attachPath: '',
            attachType: 'UC',
            certificateNo: '',
            certificateType: 0,
          },
          {
            attachName: '',
            attachPath: '',
            attachType: 'PPN',
            certificateNo: '',
          },
        ],
        certificateType: 0,
        email: '',
        mobile: '',
        paycenterLoginAccount: '',
        realName: '',
        role: [],
      },
      rules: {
        certificateNo: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              const attachObj = this.ruleForm.accountUserAttachTempAOList[0];
              if (!value) {
                callback('请输入证件号码');
              } else if (
                !idCardReg.test(value) &&
                attachObj.certificateType === 0
              ) {
                callback('证件号码格式错误');
              } else {
                const res = await Api.checkEpayAccountUserIDNumberUnique({
                  certificateType: attachObj.certificateType,
                  idnumber: attachObj.certificateNo,
                });
                if (res.code === '200' && !res.data.status) {
                  callback(res.data.msg);
                }
              }
              callback();
            },
            trigger: 'blur',
          },
        ],
        attachPath: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              switch (rule.field) {
                // 证件复印件
                case 'operatorCertificate':
                  if (!this.fileListUC.length) {
                    callback('请上传');
                  }
                  break;
                // 个人信息处理告知同意书
                case 'notificationLetter':
                  if (!this.fileListPPN.length) {
                    callback('请上传');
                  }
                  break;
                default:
                  if (!value) {
                    callback('请上传');
                  }
                  break;
              }
              callback();
            },
            trigger: 'change',
          },
        ],
        realName: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur',
          },
        ],
        paycenterLoginAccount: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入支付平台登录名称'));
              } else {
                const res = await Api.checkEpayAccountUserLoginAccountUnique({
                  paycenterLoginAccount: value,
                });
                if (res.code === '200' && !res.data.status) {
                  callback(res.data.msg);
                }
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (!mobileReg.test(value)) {
                callback(new Error('请输入正确的手机号'));
              } else {
                const res = await Api.checkEpayAccountUserMobileUnique({
                  mobile: value,
                });
                if (res.code === '200' && !res.data.status) {
                  callback(res.data.msg);
                }
              }
              callback();
            },
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (!emailReg.test(value)) {
                callback(new Error('请输入正确的邮箱地址'));
              } else {
                const res = await Api.checkEpayAccountUserEmailUnique({
                  email: value,
                });
                if (res.code === '200' && !res.data.status) {
                  callback(res.data.msg);
                }
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        role: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (!value.length) {
                callback(new Error('请选择用户权限'));
              } else {
                if (value.includes('F002') && value.includes('F003')) {
                  callback(new Error('不能同时选择经办和审核'));
                }
                // 验证经办或审核人数不能超过3人（含本次选择）
                const res = await Api.addEpayAccountUserRoleCheck({
                  role: value.join(','),
                });
                if (res.code === '200' && !res.data.status) {
                  callback(res.data.msg);
                }
                callback();
              }
            },
            trigger: 'change',
          },
        ],
      },
    };
  },
  watch: {},
  created() {},
  methods: {
    async initData() {},
    // 下载模板
    async downloadTemplate() {
      const path = `${downloadTemplateUrl}/%E4%B8%AA%E4%BA%BA%E4%BF%A1%E6%81%AF%E5%A4%84%E7%90%86%E5%91%8A%E7%9F%A5%E5%90%8C%E6%84%8F%E4%B9%A6%E6%98%93%E6%94%AF%E4%BB%98-%E5%A4%9A%E4%BA%BA%E6%A8%A1%E5%BC%8F.docx`;
      window.open(path);
    },
    // 操作人附件上传
    userUploadSuccess(attachObj, index) {
      console.log(attachObj, 'attachObj');
      this.reUploadFlag = true;
      this.$set(
        this.ruleForm.accountUserAttachTempAOList[index],
        'attachName',
        attachObj[0]?.response.data.fileName
      );
      this.$set(
        this.ruleForm.accountUserAttachTempAOList[index],
        'attachPath',
        attachObj[0]?.response.data.url
      );
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      console.log(
        this.ruleForm.accountUserAttachTempAOList,
        'accountUserAttachTempAOList'
      );
    },
    // 提交
    async handleSubmit() {
      const formName = ['applicantInfo', 'ukeyRecipientInfo'];
      const validates = (item) => {
        return new Promise((resolve, reject) => {
          if (!this.$refs[item]?.$refs.ruleForm) {
            reject();
          }
          this.$refs[item].$refs.ruleForm.validate((valid) => {
            if (valid) {
              resolve();
            }
          });
        });
      };
      const userForm = new Promise((resolve) => {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            resolve();
          }
        });
      });
      Promise.all([userForm, ...formName.map((item) => validates(item))]).then(
        () => {
          this.ruleForm.certificateType =
            this.ruleForm.accountUserAttachTempAOList[0].certificateType;
          this.handleSave();
        }
      );
    },
    // 保存
    async handleSave() {
      const params = {
        accountUserUkeyTempAO: { ...this.$refs.ukeyRecipientInfo.ruleForm },
        ..._.cloneDeep(this.$refs.applicantInfo.ruleForm),
        ...this.ruleForm,
        role: this.ruleForm.role?.join(','),
      };
      params.accountUserApplicantAttachAOList.forEach((item) => {
        // 申请人证件
        if (item.attachType === 'AC') {
          item.certificateValidityBegin = item.certificateTimeRange?.[0];
          item.certificateValidityEnd = item.certificateTimeRange?.[1];
          delete item.certificateTimeRange;
        }
        item.isLongTernEffective = item.isLongTernEffective ? 1 : 0;
      });
      if (params.accountUserUkeyTempAO.provinceId) {
        params.accountUserUkeyTempAO.province =
          this.$refs.ukeyRecipientInfo.provinceList.find(
            (item) => item.areaId === params.accountUserUkeyTempAO.provinceId
          )?.areaName;
      }
      if (params.accountUserUkeyTempAO.cityId) {
        params.accountUserUkeyTempAO.city =
          this.$refs.ukeyRecipientInfo.cityList.find(
            (item) => item.areaId === params.accountUserUkeyTempAO.cityId
          )?.areaName;
      }
      if (params.accountUserUkeyTempAO.districtId) {
        params.accountUserUkeyTempAO.district =
          this.$refs.ukeyRecipientInfo.districtList.find(
            (item) => item.areaId === params.accountUserUkeyTempAO.districtId
          )?.areaName;
      }
      console.log(params, 'params');
      Api.addAccountUserApply(params).then((res) => {
        if (res.code === '200') {
          this.$message.success('提交成功');
          this.handleReturn();
        }
      });
    },
    handleConfirmReturn() {
      this.$confirm('是否取消新增用户申请操作，点击确认关闭当前弹窗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.handleReturn();
      });
    },
    handleReturn() {
      bus.$emit('close_current_tags');
      this.$router.replace('/paymentAccount');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/common.scss';
</style>
